// src/lib/path-safety.ts
import { resolve, relative, isAbsolute } from "path";
var SLUG_PATTERN = /^[a-zA-Z0-9._-]+$/;
var MAX_SLUG_LENGTH = 128;
function isValidProjectSlug(slug) {
  return typeof slug === "string" && slug.length > 0 && slug.length <= MAX_SLUG_LENGTH && SLUG_PATTERN.test(slug) && !slug.includes("..");
}
function assertValidProjectSlug(slug) {
  if (!isValidProjectSlug(slug)) {
    throw new Error(`Invalid project slug: ${String(slug)}`);
  }
}
function resolveProjectPath(workspaceRoot, slug) {
  assertValidProjectSlug(slug);
  const root = resolve(workspaceRoot);
  const projectPath = resolve(root, slug);
  const rel = relative(root, projectPath);
  if (!rel || rel.startsWith("..") || isAbsolute(rel)) {
    throw new Error(`Invalid project slug: ${slug}`);
  }
  return projectPath;
}
function isSafeRelativePath(relPath) {
  if (typeof relPath !== "string" || relPath.length === 0 || relPath.includes("\0")) {
    return false;
  }
  if (relPath.startsWith("/") || relPath.startsWith("\\")) return false;
  if (/^[a-zA-Z]:/.test(relPath)) return false;
  return !relPath.split(/[\\/]/).some((segment) => segment === "..");
}
function resolveWithinProject(projectPath, relPath) {
  if (typeof relPath !== "string" || relPath.length === 0 || relPath.includes("\0")) {
    throw new Error(`Invalid file path: ${String(relPath)}`);
  }
  const fullPath = resolve(projectPath, relPath);
  const rel = relative(projectPath, fullPath);
  if (!rel || rel.startsWith("..") || isAbsolute(rel)) {
    throw new Error("Invalid file path - outside project directory");
  }
  return fullPath;
}
export {
  assertValidProjectSlug,
  isSafeRelativePath,
  isValidProjectSlug,
  resolveProjectPath,
  resolveWithinProject
};
//# sourceMappingURL=path-safety.js.map